import React from "react";

const Footer = () => {
  return (
    <footer className="app-footer">
      All rights reserved &copy; Ravi
    </footer>
  );
};

export default Footer;
